import R from 'ramda'
import invariant from './invariant'
import padStart from 'lodash.padstart'

export default (fileName, propertyId, size) => {
  invariant(R.type(fileName) == "String", "fileName must be a string")
  invariant(R.type(size) == "Number", "size must be a number")
  
  const prefix = padStart(propertyId.toString(), 8, '0')
  const p = R.splitAt(4, prefix)
  const [_str , name, extension] = fileName.match(/(.*)\.(.*)/)
  return `${p[0]}/${p[1]}/${name}-${size}.${extension}`
}



/** WEBPACK FOOTER **
 ** ./app/utils/photoUrlFormatter.js
 **/